/**
 * @param {*string} name
 * @return {string|null}
 */
export const getCookie = (name) => {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2){
        return parts.pop().split(";").shift();
    }
    return null;
}

/**
 * Defini le cookie 'devis"
 * @param {array} value
 * @return {void}
 */
export const setDevisCookie = (value) =>
{
    // On génère la date d'expiration du cookie devis à 24h
    let now = new Date();
    let time = now.getTime();
    let expireTime = time + 1000*24*3600;
    now.setTime(expireTime);
    // On génère le cookie
    document.cookie = 'devis=' + JSON.stringify(value) + ';expires=' + now.toGMTString() + ';path=/';
}

/**
* Empeche de saisir autre chose dans le champ de devis des fiches produit
* Source: https://stackoverflow.com/questions/17209180/jquery-keyup-function-check-if-number
* @return {void}
*/
export const checkNumber = (event) => {

	if(event === undefined) return;

	if(event.which != 8 && isNaN(String.fromCharCode(event.which))){
		event.preventDefault(); //stop character from entering input
	}
}